// KB View — samodzielny JS bundle dla publicznego widoku bazy wiedzy
// Zawiera tylko controllery używane w szablonach KB view

import { Application } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"

// --- Controllery ---
import DropdownController from "../controllers/dropdown_controller"
import EntryViewController from "../controllers/entry_view_controller"
import KbSearchController from "../controllers/kb_search_controller"
import HeaderController from "../controllers/header_controller"
import SidebarController from "../controllers/sidebar_controller"
import AnimatedDropdownController from "../controllers/animated_dropdown_controller"
import ModalController from "../controllers/modal_controller"
import NotificationController from "../controllers/notification_controller"
import AttachmentViewController from "../controllers/attachment_view_controller"

// ActiveStorage musi wystartować także w publicznym bundlu KB —
// inaczej direct_upload w modalu sugestii nie działa i plik leci jako
// surowy multipart zamiast signed_id (backend go wtedy odrzuca)
ActiveStorage.start()

// Stimulus
const application = Application.start()
application.warnings = true
application.debug = false
window.Stimulus = application

// Turbo — tylko turbo_stream (rating) i turbo_frame (flash notifications)
Turbo.session.drive = false

application.register("dropdown", DropdownController)
application.register("entry-view", EntryViewController)
application.register("kb-search", KbSearchController)
application.register("header", HeaderController)
application.register("sidebar", SidebarController)
application.register("animated-dropdown", AnimatedDropdownController)
application.register("modal", ModalController)
application.register("notification", NotificationController)
application.register("attachment-view", AttachmentViewController)

// --- Utility functions ---

// Kopiuj stronę jako Markdown (fetch .md endpoint)
window.copyEntryMarkdown = function(mdUrl, el) {
  if (!el) return
  const orig = el.textContent
  el.textContent = "..."
  fetch(mdUrl, { headers: { Accept: "text/markdown" } })
    .then(function(r) { return r.text() })
    .then(function(t) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(t)
      } else {
        const ta = document.createElement("textarea")
        ta.value = t; ta.style.position = "fixed"; ta.style.opacity = "0"
        document.body.appendChild(ta); ta.select(); document.execCommand("copy")
        document.body.removeChild(ta)
      }
      el.textContent = "Skopiowano! "
      setTimeout(function() { el.textContent = orig }, 2000)
    })
}

// Zamykanie dropdown przy kliknięciu poza nim
document.addEventListener("click", function(e) {
  const dropdown = document.getElementById("entry-actions-dropdown")
  if (dropdown && !dropdown.contains(e.target)) {
    const menu = dropdown.querySelector(".entry-actions-menu")
    if (menu) menu.classList.add("hidden")
  }
})

console.log("intum kb-view js v1.0.1")
